import React from "react";
import Ai from "../assets/Images/ai_robo-removebg-preview.png";

interface AiModeProps {
    open: boolean;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

function AiMode({ open, setOpen }: AiModeProps) {
    return (
        <>
            {/* AI Floating Button */}
            <div
                onClick={() => setOpen(!open)}
                className="
                    fixed
                    bottom-6
                    right-6
                    z-50
                    w-16
                    h-16
                    rounded-full
                    bg-white
                    shadow-[0_8px_30px_rgba(0,0,0,0.25)]
                    cursor-pointer
                    flex
                    items-center
                    justify-center
                    border
                    border-gray-200
                    hover:scale-105
                    transition-transform
                    "
            >
                <img
                    src={Ai}
                    alt="AI Assistant"
                    className="w-12 h-12 object-contain"
                />
            </div>
        </>
    );
}

export default AiMode;